// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"10e7a5b9","389":"48e4f93b","589":"f629c242"}[chunkId] + ".chunk.js";
};